import { Badge } from "../ui/badge";
import { formatCurrency } from "../../lib/utils";

export default function LoyaltyCardPreview({ customer, config, currentLevel, restaurantName }) {
  const pc = config?.primary_color || "#F97316";
  const sc = config?.secondary_color || "#1F2937";
  
  return (
    <div
      className="relative rounded-2xl p-6 text-white overflow-hidden shadow-xl"
      style={{ background: `linear-gradient(135deg, ${pc}, ${sc})`, minHeight: "180px" }}
    >
      <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full opacity-10 bg-card" />
      <div className="absolute -bottom-6 -left-6 w-32 h-32 rounded-full opacity-10 bg-card" />
      <div className="relative flex justify-between items-start mb-4">
        <div>
          <p className="text-xs opacity-70 uppercase tracking-wider font-medium">{config?.program_name || "Club de Fidelización"}</p>
          <p className="font-bold text-lg mt-1">{restaurantName || "Restaurante"}</p>
        </div>
        {currentLevel && (
          <Badge className="text-xs font-semibold border-0" style={{ background: currentLevel.color || "#FFD700", color: "#1F2937" }}>
            {currentLevel.name}
          </Badge>
        )}
      </div>
      <p className="relative text-xl font-bold tracking-wide">{customer?.name || "Cliente"}</p>
      <div className="relative flex items-end justify-between mt-3">
        <div>
          <p className="text-3xl font-black">{customer?.points || 0}</p>
          <p className="text-xs opacity-70">puntos disponibles</p>
        </div>
        <div className="text-right text-xs opacity-70">
          <p>{customer?.total_visits || 0} visitas</p>
          <p>{formatCurrency(customer?.total_spent || 0)} gastado</p>
        </div>
      </div>
    </div>
  );
}
